import _ from "lodash";
import Swal from "sweetalert2";
import { DateTime } from "luxon";
export function amountByPercent(percent, total) {
  if (isNaN(percent) || isNaN(total)) {
    return 0;
  }
  return _.round((parseFloat(percent) / 100) * total);
}

export function percentByAmount(amount, total) {
  if (isNaN(amount) || isNaN(total)) {
    return 0;
  }
  return _.round((parseFloat(amount) / total) * 100, 2);
}

export function formatCurrency(value, currency = "IDR") {
  return value.toLocaleString("en-US", { style: "currency", currency });
}

export function formatPercent(value, decimals = 2, alwaysPositive = false) {
  if (value < 0 && alwaysPositive == true) {
    value = value * -1;
  }
  let percent =
    value.toLocaleString(undefined, {
      maximumFractionDigits: decimals,
    }) + " %";
  return percent;
}
export function ratioFormat(value, decimals = 2, alwaysPositive = false) {
  if (value < 0 && alwaysPositive == true) {
    value = value * -1;
  }
  let ratioNumber = value.toLocaleString(undefined, {
    maximumFractionDigits: decimals,
  });
  return ratioNumber;
}
export function abbrNum(number, decPlaces) {
  // check if number negative or positive
  let postiveNumber = true;
  if (number < 0) {
    postiveNumber = false;
    number = number * -1;
  }

  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);

  // Enumerate number abbreviations
  var abbrev = ["K", "M", "B", "T", "Qa", "Qi", "Sx", "Sp", "Oc"];

  // Go through the array backwards, so we do the largest first
  for (var i = abbrev.length - 1; i >= 0; i--) {
    // Convert array index to "1000", "1000000", etc
    var size = Math.pow(10, (i + 1) * 3);

    // If the number is bigger or equal do the abbreviation
    if (size <= number) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      number = Math.round((number * decPlaces) / size) / decPlaces;

      // Handle special case where we round up to the next abbreviation
      if (number == 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }

      // Add the letter for the abbreviation
      number += abbrev[i];

      // We are done... stop
      break;
    }
  }

  // Keep do rounding even though the number below 1000
  if (number < 1000) {
    number = Math.round(number * decPlaces) / decPlaces;
  }

  if (postiveNumber == false) {
    number = "-" + number;
  }

  return number;
}

export function abbrMonthName(monthName) {
  switch (monthName) {
    case "January":
      monthName = "Jan";
      break;
    case "February":
      monthName = "Feb";
      break;
    case "March":
      monthName = "Mar";
      break;
    case "April":
      monthName = "Apr";
      break;
    case "May":
      monthName = "May";
      break;
    case "June":
      monthName = "Jun";
      break;
    case "July":
      monthName = "Jul";
      break;
    case "August":
      monthName = "Aug";
      break;
    case "September":
      monthName = "Sep";
      break;
    case "October":
      monthName = "Oct";
      break;
    case "November":
      monthName = "Nov";
      break;
    case "December":
      monthName = "Dec";
      break;
    default:
      monthName = monthName;
      break;
  }

  return monthName;
}

export function calculateTax(
  value,
  values,
  variable = "",
  type = "",
  index = 0,
  setFieldValue,
  propertyAddCost = ""
) {
  let taxPercent = 0;
  let taxAmount = 0;
  if (isNaN(value)) {
    value = 0;
  }
  if (type === "percent") {
    taxPercent = parseFloat(value);
  } else if (type === "amount") {
    taxAmount = parseFloat(value);
  }
  if (index >= 0) {
    const totalPrice = parseFloat(
      values[variable][index].unitPrice * values[variable][index].qty
    );
    const discountAmount = parseFloat(values[variable][index].discountAmount);
    if (type === "percent") {
      taxAmount = amountByPercent(taxPercent, totalPrice - discountAmount);
    } else if (type === "amount") {
      taxPercent = percentByAmount(taxAmount, totalPrice - discountAmount);
    }
    const dataItem = [...values[variable]];
    dataItem[index].taxPercent = taxPercent;
    dataItem[index].taxAmount = taxAmount;
    setFieldValue(variable, dataItem);
  } else {
    const discountAmount = parseFloat(values.discountAmount);
    const subTotal = values.subTotal;
    if (type === "percent") {
      taxAmount = amountByPercent(taxPercent, subTotal - discountAmount);
    } else if (type === "amount") {
      taxPercent = percentByAmount(taxAmount, subTotal - discountAmount);
    }
    setFieldValue("taxAmount", taxAmount);
    setFieldValue("taxPercent", taxPercent);
    let totalAddCost = 0;
    if (typeof values[propertyAddCost] !== "undefined") {
      for (const addCost of values[propertyAddCost]) {
        totalAddCost += addCost.costPrice;
      }
    }
    let grandTotal = subTotal - discountAmount + taxAmount;
    grandTotal += totalAddCost;
    setFieldValue("grandTotal", grandTotal);
  }
}

export function calculateDiscount(
  value,
  values,
  variable = "",
  type = "",
  index = 0,
  setFieldValue,
  propertyAddCost = ""
) {
  let discountPercent = 0;
  let discountAmount = 0;
  if (isNaN(value)) {
    value = 0;
  }
  if (type === "percent") {
    discountPercent = parseFloat(value);
  } else if (type === "amount") {
    discountAmount = parseFloat(value);
  }
  if (index >= 0) {
    const totalPrice = parseFloat(
      values[variable][index].unitPrice * values[variable][index].qty
    );
    const taxPercent = parseFloat(values[variable][index].taxPercent);
    if (type === "percent") {
      discountAmount = amountByPercent(discountPercent, totalPrice);
    } else if (type === "amount") {
      discountPercent = percentByAmount(discountAmount, totalPrice);
    }
    const dataItem = [...values[variable]];
    dataItem[index].discountPercent = discountPercent;
    dataItem[index].discountAmount = discountAmount;
    if (taxPercent > 0) {
      const taxAmount = amountByPercent(
        taxPercent,
        totalPrice - discountAmount
      );
      dataItem[index].taxAmount = taxAmount;
    }
    setFieldValue(variable, dataItem);
  } else {
    const subTotal = values.subTotal;
    const taxPercent = parseFloat(values.taxPercent);
    if (type === "percent") {
      discountAmount = amountByPercent(discountPercent, subTotal);
    } else if (type === "amount") {
      discountPercent = percentByAmount(discountAmount, subTotal);
    }
    let taxAmount = 0;
    setFieldValue("discountAmount", discountAmount);
    setFieldValue("discountPercent", discountPercent);
    if (taxPercent > 0) {
      taxAmount = amountByPercent(taxPercent, subTotal - discountAmount);
      setFieldValue("taxAmount", taxAmount);
    }
    let totalAddCost = 0;
    if (typeof values[propertyAddCost] !== "undefined") {
      for (const addCost of values[propertyAddCost]) {
        totalAddCost += addCost.costPrice;
      }
    }
    let grandTotal = subTotal - discountAmount + taxAmount;
    grandTotal += totalAddCost;
    setFieldValue("grandTotal", grandTotal);
  }
}

export function formatDate(dateImp, withTime = false, withTimeZone = true) {
  if (typeof dateImp !== "undefined") {
    if (dateImp.toString().includes("0001-01-01")) {
      return "";
    }
  }
  var date = DateTime.fromISO(dateImp);
  let dateString;
  if (withTime === false) {
    dateString = date.toFormat("yyyy-MM-dd");
  } else {
    if (withTimeZone === true) {
      dateString = date.toFormat("yyyy-MM-dd, hh:mm a ZZZZZ (ZZZZ)");
    } else {
      dateString = date.toFormat("yyyy-MM-dd, hh:mm a");
    }
  }

  return dateString;
}

export function formatTime(timeImp) {
  var time = new Date(timeImp);
  var h = ("00" + time.getHours()).slice(-2);
  var m = ("00" + time.getMinutes()).slice(-2);
  var pm = h - 12 <= 9 ? "0" + (h - 12) : h - 12;
  let timeString = h > 11 ? pm + ":" + m + " PM" : h + ":" + m + " AM";

  return timeString;
}

export function calculateDaysBetweenDate(
  date1 = DateTime.now(),
  date2 = DateTime.now()
) {
  const diffInDayss = date1.diff(date2, "days");
  return Math.floor(diffInDayss.toObject().days);
}

/**
 * Stop enter submitting the form.
 * Event triggered when the user presses a key.
 */
export function onPreventEnterSubmitting(keyEvent) {
  if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
    return keyEvent.preventDefault();
  }
}

export function getFileExtension(filename) {
  return filename.split(".").pop();
}

/*Linear Gradient*/
export function getGradient(ctx, chartArea) {
  let width, height, gradient;
  const chartWidth = chartArea.right - chartArea.left;
  const chartHeight = chartArea.bottom - chartArea.top;
  if (!gradient || width !== chartWidth || height !== chartHeight) {
    // Create the gradient because this is either the first render
    // or the size of the chart has changed
    width = chartWidth;
    height = chartHeight;
    gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient.addColorStop(0, "#0157ae");
    gradient.addColorStop(0.5, "#45cafc");
    gradient.addColorStop(1, "#0157ae");
  }

  return gradient;
}

export function whatsappChat(whatsappNumber, whatsappMessage) {
  if (whatsappNumber === "") {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    }).fire({
      title: "Failed",
      text: "Whatsapp Number cannot be empty",
      icon: "error",
      showCloseButton: true,
      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
    });
  } else {
    // Regex expression to remove all characters which are NOT alphanumeric
    let number = whatsappNumber.replace(/[^\w\s]/gi, "").replace(/ /g, "");

    // Appending the phone number to the URL
    let url = `https://wa.me/${number}`;

    // Appending the message to the URL by encoding it
    url += `?text=${encodeURI(whatsappMessage)}`;
    /*
    // Appending the phone number to the URL
    let url = `https://web.whatsapp.com/send?phone=${number}`;

    // Appending the message to the URL by encoding it
    url += `&text=${encodeURI(whatsappMessage)}&app_absent=0`;
    */

    // Open our newly created URL in a new tab to send the message
    window.open(url);
  }
}

export function deleteRowItem(
  property = "",
  tableItem = [],
  index = 0,
  setFieldValue
) {
  const tableItemTmp = [...tableItem];
  _.pullAt(tableItemTmp, index);
  setFieldValue(property, tableItemTmp);
}

export function sendNotification(
  socket,
  notifTypeID = 0,
  fromUserName = "",
  toUsers = []
) {
  let messages = "";
  switch (notifTypeID) {
    case 1:
      messages = "You've new message from " + fromUserName;
      break;
    case 2:
      messages = "You've new approval request from " + fromUserName;
      break;
    case 3:
      messages = "You've new task from " + fromUserName;
      break;
    default:
      break;
  }
  socket.emit("send-notifications", { messages, toUsers });
}

export function sendMessages(socket, fromUserName = "", toUsers = []) {
  socket.emit("send-messages", { messages: "reload messages", toUsers });
  sendNotification(socket, 1, fromUserName, toUsers);
}

export function sendApprovalRequests(socket, fromUserName = "", toUsers = []) {
  socket.emit("send-approval-requests", {
    messages: "reload approval requests",
    toUsers,
  });
  sendNotification(socket, 2, fromUserName, toUsers);
}

export function sendTasks(socket, fromUserName = "", toUsers = []) {
  socket.emit("send-tasks", { messages: "reload tasks", toUsers });
  sendNotification(socket, 3, fromUserName, toUsers);
}

export function setObject(
  socket,
  action = "",
  objectID = 0,
  appCode = "",
  user = {
    userID: 0,
    fullName: "",
    userName: "",
  }
) {
  objectID = parseInt(objectID);
  user.userID = parseInt(user.userID);
  return new Promise((resolve, reject) => {
    socket.emit(
      action,
      {
        objectID,
        appCode,
        userID: user.userID,
        fullName: user.fullName,
        userName: user.userName,
      },
      (response) => {
        if (response.type === "E") {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Failed",
            text: response.message,
            icon: "error",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
          reject(response);
        } else {
          resolve(response);
        }
      }
    );
  });
}

export function checkRegexPhoneNumber(phoneNumber) {
  const phoneRegex = new RegExp(
    /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/
  );
  return phoneRegex.test(phoneNumber);
}

export function checkRegexWebsite(website) {
  const websiteRegex = new RegExp(
    /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/
  );
  return websiteRegex.test(website);
}

export function checkRegexEmail(email) {
  const emailRegex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return emailRegex.test(email);
}
